module.exports = require('./helpers/bundle-url').getBundleURL('6NLDm') + "logo-dark.eefe0b7f.svg";